import CustomerDataActionTypeKeys from "./ActionTypeKeys";
export function CustomerDataReducer(state = {
    CustomerData: [],
    Error: "",
    InProgress: 0,
    PartnerData: [],
}, action) {
    switch (action.type) {
        case CustomerDataActionTypeKeys.Get_CustomerData_Success:
            return Object.assign(Object.assign({}, state), { CustomerData: action.payload, Error: "", InProgress: Math.max(0, state.InProgress - 1), PartnerData: [] });
        case CustomerDataActionTypeKeys.Get_CustomerData_Failure:
            return Object.assign(Object.assign({}, state), { CustomerData: [], Error: action.payload, InProgress: Math.max(0, state.InProgress - 1), PartnerData: [] });
        case CustomerDataActionTypeKeys.Get_CustomerData_InProgress:
            return Object.assign(Object.assign({}, state), { CustomerData: [], Error: "", InProgress: action.payload ? state.InProgress + 1 : Math.max(0, state.InProgress - 1), PartnerData: [] });
        case CustomerDataActionTypeKeys.Get_PartnerData_Success:
            return Object.assign(Object.assign({}, state), { CustomerData: [], Error: "", InProgress: Math.max(0, state.InProgress - 1), PartnerData: action.payload });
        default:
            return state;
    }
}
